export interface InsightPost {
  id: string;
  title: string;
  slug: string;
  date: string;
  readingTime: string;
  tags: string[];
  excerpt: string;
  content: string;
}

export const INSIGHT_POSTS: InsightPost[] = [
  {
    id: "governance-first-agentic-systems",
    slug: "governance-first-agentic-systems",
    title: "Why Agentic Systems Must Be Governance-First",
    date: "2026-01-10",
    readingTime: "7 min read",
    tags: ["Agentic systems", "Governance", "Safety"],
    excerpt:
      "Agentic workflows are powerful, but without policy, observability, and oversight, they turn into opaque automation. This framing makes them safe enough for real organisations.",
    content:
      "Agentic AI systems promise to automate complex workflows by orchestrating tools, models, and data sources on behalf of humans.\n\nWithout governance-first design, they risk becoming opaque automation layers that leaders cannot fully trust.\n\nA governance-first approach starts from questions such as: Who is accountable for each decision class? What policies constrain actions? What must be logged for later audit? Which recommendations require human approval?\n\nIn practice, this means building policy gates, traceable decision flows, and explanation layers into the core of the architecture—not as an afterthought.",
  },
  {
    id: "llm-observability-beyond-logs",
    slug: "llm-observability-beyond-logs",
    title: "LLM Observability: Beyond Logs and Latency",
    date: "2025-06-18",
    readingTime: "6 min read",
    tags: ["Observability", "LLMs", "Production"],
    excerpt:
      "Most teams start with simple logging and error metrics for LLM systems. That's not enough. Here's what serious observability for AI should include.",
    content:
      "LLM systems do not fail like traditional microservices. They can hallucinate, degrade quietly under distribution shift, or behave differently with small prompt changes.\n\nAn observability stack for LLMs should treat prompts, context windows, tool calls, and outputs as first-class telemetry. It should capture safety triggers, policy violations, and user feedback signals.\n\nCombined, these signals allow teams to debug behaviour, spot regressions, and make risk-based rollout decisions.\n\nThe goal is not just uptime, but confidence: confidence that the system is behaving within acceptable bounds, and that failures can be detected, explained, and corrected.",
  },
  {
    id: "from-pocs-to-governed-ai",
    slug: "from-pocs-to-governed-ai",
    title: "From AI Proof-of-Concepts to Governed Systems in Production",
    date: "2025-03-25",
    readingTime: "8 min read",
    tags: ["Strategy", "Transformation", "Governance"],
    excerpt:
      "Many organisations are stuck in PoC land. This article describes a practical path from AI demos to governed, observable systems in production.",
    content:
      "PoCs are useful for exploration, but a terrible place to stop. The gap between a demo and a production-ready AI system is usually made up of missing observability, unclear ownership, no governance model, and weak integration into real workflows.\n\nA pragmatic path forward focuses on a small number of use-cases, defines clear success metrics, designs a minimal governance and observability layer, and then iterates.\n\nRather than aiming for a perfect AI platform from day one, organisations can grow capability alongside adoption: start small, make it safe, make it observable, and then scale.\n\nThe result is not just more AI, but AI that leaders are willing to bet the business on.",
  },
];




